import { create } from "zustand";

type Currency = string;

interface DisplayCurrencyStore {
  displayCurrency: Currency;
  setDisplayCurrency: (currency: Currency) => void;
}

export const useDisplayCurrencyStore = create<DisplayCurrencyStore>((set) => ({
  displayCurrency: "USD",
  setDisplayCurrency: (currency) => set({ displayCurrency: currency }),
}));
